import { render, staticRenderFns } from "./MarketRates.vue?vue&type=template&id=1b2af631&scoped=true&"
import script from "./MarketRates.vue?vue&type=script&lang=js&"
export * from "./MarketRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2af631",
  null
  
)

export default component.exports